import { differenceInCalendarDays } from "date-fns";
import { parseDateOnlyAsUTC } from "@common/helpers/date";
import { pluralizeWithCount } from "@common/helpers/string";
import { getLocalTodayDateOnly } from "@helpers/date";
import type { ClientsWorkOverviewWorkRow } from "./clientsWorkOverviewViewConfig";

/** Days open work is past its Work end, or null when it isn't late (or is done or canceled). */
export const getWorkOverdueDays = ({
    row,
    today,
}: {
    row: Pick<
        ClientsWorkOverviewWorkRow,
        "isFinished" | "cancelledAt" | "workDeliveryDate"
    >;
    today: string;
}): number | null => {
    if (row.isFinished || row.cancelledAt !== null || !row.workDeliveryDate) {
        return null;
    }
    const days = differenceInCalendarDays(
        parseDateOnlyAsUTC(today),
        parseDateOnlyAsUTC(row.workDeliveryDate),
    );
    return days > 0 ? days : null;
};

/** "4 days overdue" for the Work end cell and chip. */
export const formatOverdueDays = (days: number) =>
    `${pluralizeWithCount("day", days)} overdue`;

/** "4 days overdue" when open work is past its Work end today, else null. */
export const getWorkOverdueLabel = (
    row: Pick<
        ClientsWorkOverviewWorkRow,
        "isFinished" | "cancelledAt" | "workDeliveryDate"
    >,
) => {
    const days = getWorkOverdueDays({ row, today: getLocalTodayDateOnly() });
    return days === null ? null : formatOverdueDays(days);
};
